<!--
 * @Author: daidongyu
 * @Date: 2022-04-20 16:29:29
 * @LastEditTime: 2022-04-28 13:40:12
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /my-activation/src/addAdress/index.vue
-->
<template>
  <div class="addAdress">
    <div class="Requirement">
      <div class="letRe fl">联系人</div>
      <input class="rigRe fr" placeholder="请填写姓名" v-model="contactName" />
    </div>
    <!-- <div class="Requirement">
      <div class="letRe fl">性别</div>
      <div>
        <mt-radio v-model="sex" :options="options"> </mt-radio>
      </div>
    </div> -->
    <div class="Requirement">
      <div class="letRe fl">手机号</div>
      <input
        class="rigRe fr"
        placeholder="请输入手机号"
        v-model="contactPhone"
      />
    </div>
    <div class="Requirement">
      <div class="letRe fl">详细地址</div>
      <input
        class="rigRe fr"
        placeholder="请输入详细地址"
        v-model="addressDesc"
      />
    </div>
    <div class="Requirement">
      <div class="letRe fl">默认地址</div>
      <div class="swich_moren">
        <div></div>
        <mt-switch v-model="isDefault"></mt-switch>
      </div>
    </div>
    <div class="save_add" @click="handlePreserve">
      保存地址
    </div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
export default {
  name: "Detail",
  data() {
    return {
      openID: localStorage.getItem("code"),
      contactName: "",
      sex: "1",
      contactPhone: "",
      addressDesc: "",
      isDefault: true,
      id: ""
    };
  },
  mounted() {
    if (this.$route.query.value) {
      let data = JSON.parse(this.$route.query.value);
      const { contactPhone, addressDesc, isDefault, contactName, id } = data;
      this.contactPhone = contactPhone;
      this.addressDesc = addressDesc;
      this.isDefault = isDefault;
      this.contactName = contactName;
      this.id = id;
      console.log(this.$route.query);
    }
  },
  methods: {
    handlePreserve() {
      if (!this.contactName || !this.contactPhone || !this.addressDesc) {
        Toast("请补全信息后保存！");
        return;
      }
      var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!reg_tel.test(this.contactPhone)) {
        Toast("请输入正确的手机号");
        return;
      }
      if (this.id) {
        this.RequestMall(
          "PUT",
          `h5/mall/address/${this.id}`,
          {
            contactName: this.contactName,
            contactPhone: this.contactPhone,
            addressDesc: this.addressDesc,
            isDefault: this.isDefault
          },
          r => {
            if (r.data.code === "20000") {
              Toast("修改成功！");
              setTimeout(() => {
                window.location.href = "/#/Order";
              }, 2000);
            }
          }
        );
      } else {
        this.RequestMall(
          "POST",
          "h5/mall/address",
          {
            openID: this.openID,
            contactName: this.contactName,
            contactPhone: this.contactPhone,
            addressDesc: this.addressDesc,
            isDefault: this.isDefault
          },
          r => {
            if (r.data.code === "20000") {
              Toast("添加成功！");
              setTimeout(() => {
                window.location.href = "/#/Order";
              }, 2000);
            }
            console.log(r, "resssssssss");
          }
        );
      }
    }
  }
};
</script>
<style scoped>
.addAdress {
  width: 100%;
  box-sizing: border-box;
  padding: 0 11px;
  /* margin-left: 3%; */
  background: #fff;
  border-radius: 5px;
  /* height: 100%; */
  /* box-shadow: 0px 0px 5px 0px #bdbdbd; */
  position: relative;
}
.Requirement {
  height: 35px;
  line-height: 35px;
  font-size: 11px;
  color: #212121;
  position: relative;
  border-bottom: solid 1px #eeeeee;
}
.letRe {
  width: 22%;
  height: 100%;
  font-size: 10px;
  color: #757575;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.rigRe {
  display: block;
  height: 100%;
  width: 75%;
  border: none;
  font-size: 11px;
}
input::-webkit-input-placeholder {
  color: #bdbdbd;
  font-size: 11px;
}
input {
  outline: none;
  text-align: right;
}
.swich_moren {
  height: 100%;
  width: 75%;
  display: flex;
  justify-content: space-between;
}
.save_add {
  position: fixed;
  bottom: 80px;
  width: 85%;
  left: 7.5%;
  height: 29px;
  font-size: 11px;
  text-align: center;
  line-height: 29px;
  color: #ffffff;
  background: linear-gradient(95deg, #ff5a61 0%, #ff9c60 100%);
  opacity: 1;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/addAdress/index.vue